module.exports = __webpack_public_path__ + "img/des-main-background-1980.6d4bd553.jpeg";